import { render, staticRenderFns } from "./SharingSection.vue?vue&type=template&id=7c805356&"
import script from "./SharingSection.vue?vue&type=script&lang=js&"
export * from "./SharingSection.vue?vue&type=script&lang=js&"
import style0 from "./SharingSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports